// extracted by mini-css-extract-plugin
export var currentCountry = "styles-module--currentCountry--8db0c";
export var dropdownSelector = "styles-module--dropdownSelector--f8f14";
export var selectorWrapper = "styles-module--selectorWrapper--56d19";